<homey-notification-dialog-content [title]="title()" [closeButton]="closeButton()" [noBottomMargin]="true">
  <p class="text-surface-600">
    {{ bodyMessage() }}
  </p>

  @if (step() === 'rating') {
    <div class="flex justify-center py-2">
      <p-rating
        [(ngModel)]="rating"
        [stars]="5"
        [required]="true"
        [iconOnStyle]="{ color: 'orange', fontSize: '1.75rem' }"
        [iconOffStyle]="{ color: 'orange', fontSize: '1.75rem' }"
      >
      </p-rating>
    </div>
  }

  @if (step() === 'feedback') {
    <p-floatlabel variant="on" class="mt-6">
    <label class="text-sm">Please give us your thoughts, we look at everything.</label>
    <textarea
      pTextarea
      class="w-full"
      rows="4"
      style="resize: none"
      [(ngModel)]="description">
    </textarea>
    </p-floatlabel>
  }

  <div class="mt-4 flex gap-3 justify-center">
    @if (step() !== 'done') {
      <homey-form-buttons
        class="w-full"
        [small]="true"
        [around]="true"
        [buttons]="[
          { label: 'Not now', value: 'no', severity: 'secondary' },
          { label: primaryLabel(), value: 'yes', severity: 'primary', disabled: (step() === 'rating' && rating() === 0) || (step() === 'feedback' && description().trim().length === 0) }
        ]"
        [submitFunction]="onFormAction">
      </homey-form-buttons>
    } @else {
      <homey-submit-button
        [size]="'small'"
        [severity]="'primary'"
        [submitFunction]="onConfirm"
        [submitButtonLabel]="primaryLabel()">
        Hello?
      </homey-submit-button>
    }
  </div>
</homey-notification-dialog-content>
